import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "../../../partials/content/Card";
import { GetAccessRights } from "../../../router/Protector/Protector";
import SystemHelper from "../../../shared/systemHelper";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.customFieldsEnabled = SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED);
    this.customFieldsEnabledForClientRoles = process.env.REACT_APP_CLIENT_MANAGES_CUSTOM_FIELDS === "true";
    this.batchOperationsEnabled = process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true";
    this.themeSettingEnabled = process.env.REACT_APP_THEME_SETTING_ENABLED === "true";

    this.accessTags = GetAccessRights("/admin/settings/tags", this.props.userProfile).allowAccess;
    this.accessContractTypes = GetAccessRights("/admin/settings/contract-types", this.props.userProfile).allowAccess;
    this.accessCustomizeTheme = GetAccessRights("/admin/settings/customize-theme", this.props.userProfile).allowAccess;
    this.accessSystemSettings = GetAccessRights("/admin/settings/system", this.props.userProfile).allowAccess;
    this.accessCustomFields = GetAccessRights("/admin/settings/custom-fields", this.props.userProfile).allowAccess;
    this.accessWebHooks = GetAccessRights("/admin/settings/webhook", this.props.userProfile).allowAccess;
    this.accessMigration = GetAccessRights("/admin/settings/migration", this.props.userProfile).allowAccess;
    this.accessAISettings = GetAccessRights("/admin/settings/ai-settings", this.props.userProfile).allowAccess;
    this.renderCustomFieldCard = false

    const { customFieldsEnabled, accessCustomFields, customFieldsEnabledForClientRoles } = this;
    const { accounttype } = this.props.userProfile;

    if (customFieldsEnabled && accessCustomFields) {
      this.renderCustomFieldCard = true;
      if (!customFieldsEnabledForClientRoles && (accounttype === "Site Administrator" || accounttype === "Company Administrator")) {
        this.renderCustomFieldCard = false;
      }
    }
  }

  render() {
    return (

      <div className="container">
        <div className="row g-4 g-xl-9 mb-6 mb-xl-9">
          {this.accessTags && (
            <Card title="Tags" url="/admin/settings/tags" description="Create and edit instance level Tag definitions" icon="/media/icons/svg/Shopping/Price1.svg" />
          )}
          {this.accessSystemSettings && (
            <>
              <Card title="Features" description="Turn on/off instance level features" icon="/media/icons/svg/General/Settings-1.svg" />
              <Card title="System Settings" url="/admin/settings/system" description="System setting configurations" icon="/media/icons/svg/Code/Settings4.svg" />
            </>
          )}
        </div>
        <div className="row g-4 g-xl-9 mb-6 mb-xl-9">
          {this.renderCustomFieldCard && (
            <Card title="Custom Fields" url="/admin/settings/custom-fields" description="Create and edit Custom Fields" icon="/media/icons/svg/Media/Playlist2.svg" />
          )}
          {(this.accessWebHooks && process.env.REACT_APP_WEBHOOKS_ENABLED === 'true') && (
            <Card title="Connections" url="/admin/settings/webhook" description="Connection configurations" icon="/media/icons/svg/Code/Git3.svg" />
          )}
          {(this.batchOperationsEnabled && this.accessMigration) && (
            <Card title="Migration" url="/admin/settings/migration" description="System migration tool" icon="/media/icons/svg/Code/Upload-folder.svg" />
          )}
        </div>
        <div className="row g-4 g-xl-9 mb-8 mb-xl-9">
          {this.accessContractTypes && (
            <Card title="Contract Types" url="/admin/settings/contract-types" description="Manage contract types" icon="/media/icons/svg/Files/folder-document.svg" />
          )}
          {(this.themeSettingEnabled && this.accessCustomizeTheme) && (
            <Card title="Customize Theme" url="/admin/settings/customize-theme" description="Customize theme" icon="/media/icons/svg/Design/Color.svg" />
          )}
          {this.accessAISettings && (
            <Card title="AI Settings" url="/admin/settings/ai-settings" description="AI Settings Configuration" icon="/media/icons/svg/Code/Settings4.svg" />
          )}
        </div>
      </div>
      // <Portlet>
      //     <PortletHeader title="System Settings" />
      //     <PortletBody >
      //       <TabPanel
      //           width="100%"
      //           deferRendering={false}
      //           animationEnabled={true}
      //           swipeEnabled={true}>
      //           {this.props.isSystemOwner && (<Item title={"General"} render={this.tabGeneral} />)}
      //           <Item title={"Tags"} render={this.tabTag} />
      //       </TabPanel>
      //     </PortletBody>
      // </Portlet>
    );
  }
}

const mapStateToProps = store => ({
  userProfile: store.auth.userProfile,
});

export default connect(mapStateToProps)(Settings);
